module.exports = __webpack_public_path__ + "img/wind.be5030ca.webp";